<script lang="ts">
	import type { SelectFile, SelectTeacherDetails } from '$db/tables';
	import { PUBLIC_BASE_URL } from '$env/static/public';
	import * as Card from '$lib/components/ui/card';
	import { Image } from '@unpic/svelte';

	interface Props {
		teachers: {
			userDetails: {
				firstName: string;
				lastName: string;
			} | null;
			tD:
				| (Omit<SelectTeacherDetails, 'userId'> & {
						image: SelectFile | null;
				  })
				| null;
			instituteHead: { name: string }[];
			facultyHead: { name: string }[];
		}[];
	}

	let { teachers }: Props = $props();
</script>

<div class="grid grid-cols-1 gap-4 md:grid-cols-7">
	{#each teachers as teacher}
		<Card.Root class="flex flex-col overflow-clip shadow-none">
			<a href="/team/{teacher.tD?.slug}" class="h-full">
				<Card.Header class="p-0">
					<div class="flex bg-asge-800">
						<Image
							class="object-cover object-center text-[0px] opacity-85"
							cdn="directus"
							src="{PUBLIC_BASE_URL}/api/img?objectKey={teacher.tD?.image?.objectKey}"
							layout="constrained"
							height={500}
							width={500}
							alt={`${teacher.userDetails?.firstName} ${teacher.userDetails?.lastName}`}
						/>
					</div>
				</Card.Header>
				<Card.Footer class="flex-1 items-start pt-4">
					<Card.Title class="text-lg leading-5">
						{teacher.userDetails?.firstName}
						{teacher.userDetails?.lastName}
					</Card.Title></Card.Footer
				>
			</a>
		</Card.Root>
	{/each}
</div>
